import { Injectable } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { Location } from "@angular/common";

import { Bet } from "../models/bet";
import { Card } from "../models/card";
import { Event } from "../models/events/event";
import { OnlineCredit } from "../models/online-credit";

@Injectable({ providedIn: "root" })
export class PrintingService {
  private content: any = null;
  private type: any = null;
  private mode: any = null;

  isPrinting = false;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private location: Location,
  ) {}

  _onDataReady() {
    setTimeout(async () => {
      window.print();
      // setting printing flag
      this.isPrinting = false;
      // clearing content
      this.content = null;
      this.location.back();
    });
  }

  _getContent(): any {
    return this.content;
  }

  private _print(type: string, content: any) {
    // setting printing flag
    this.isPrinting = true;
    // setting content
    this.content = content;
    this.router.navigate(["/", { outlets: { printing: ["print", type] } }], {});
  }

  printCoupon(coupon: Bet, copy: boolean) {
    this._print("coupon", { coupon, copy });
  }

  printCard(card: Card) {
    this._print("card", { card });
  }

  printCredit(credit: OnlineCredit) {
    this._print("credit", { credit });
  }

  printEvents(events: Event[], type: string) {
    this._print("events", { events, type });
  }

  printCounting(summary: any, details: any[], type: string, userDetails: string, initialDate: Date, finalDate: Date, zone?: string) {
    this._print("counting", {
      summary,
      details,
      type,
      user_details: userDetails,
      initial_date: initialDate,
      final_date: finalDate,
      zone,
    });
  }
}
